import { dateTimeFormat, DeleteIcon, EditIcon, IconButton, MuiTooltip, RectangleIcon } from "@common";

  function createdBy(value, row) {
    return row?.user_created?.email;
  }
  function updatedBy(value, row) {
    return row?.user_updated?.email;
  }

export const getStatusGridColumns = ({
  statusField,
  rowSelectAction,
  permissions,
  requestDelete,
  requestEdit,
  dispatch,
  classes,
}) => [
  {
    field: statusField,
    headerName: "Status",
    width: 150,
    renderHeader: () => <strong>Status</strong>,
  },
  {
    field: "color",
    headerName: "Color",
    renderHeader: () => <strong>Color</strong>,
    width: 100,
    renderCell: (params) => (
        <RectangleIcon
          style={{
            width: "2.4rem",
            height: "1.4rem",
            color: params?.row?.colorCode,
          }}
        />
    ),
  },
  {
    field: "colorCode",
    headerName: "Color Code",
    width: 100,
    renderHeader: () => <strong>Color Code</strong>,
  },
  {
    field: "comments",
    headerName: "Comments",
    width: 760,
    renderHeader: () => <strong>Comments</strong>,
  },
  permissions?.update && {
    field: "Edit",
    type: "actions",
    renderCell: (params) => (
      <MuiTooltip title="Edit" placement="bottom">
        <IconButton
          onClick={() => {
            dispatch(rowSelectAction([params.row]));
            requestEdit();
          }}
        >
          <EditIcon style={{ color: "#808080" }} />
        </IconButton>
      </MuiTooltip>
    ),
    width: 40,
    minWidth: 40,
    maxWidth: 40,
  },
  permissions?.delete && {
    field: "Delete",
    type: "actions",
    headerClassName: classes.hideRightSeparator,
    renderCell: (params) => (
      <MuiTooltip title="Delete" placement="bottom">
        <IconButton onClick={() => requestDelete(params)}>
          <DeleteIcon sx={{ color: "red !important" }} />
        </IconButton>
      </MuiTooltip>
    ),
    width: 40,
    minWidth: 40,
    maxWidth: 40,
  },
  {
    field: "createdBy",
    headerName: "Created By",
    renderHeader: () => <strong>Created By</strong>,
    valueGetter: createdBy,
    width: 185,
  },
  {
    field: "createdOn",
    headerName: "Created On",
    renderHeader: () => <strong>Created On</strong>,
    width: 185,
    valueGetter: (value, row) => dateTimeFormat(row?.createdOn),
  },
  {
    field: "updatedBy",
    headerName: "Updated By",
    renderHeader: () => <strong>Updated By</strong>,
    valueGetter: updatedBy,
    width: 182,
  },
  {
    field: "updatedOn",
    headerName: "Updated On",
    renderHeader: () => <strong>Updated On</strong>,
    width: 182,
    valueGetter: (value, row) => dateTimeFormat(row?.updatedOn),
  },
].filter(Boolean);

export const statusFields = [
  {
    name: "status",
    label: "Status",
    type: "text",
    multiline: false,
    required: true,
    xs: 12,
    sm: 12,
    md: 8,
  },
  {
    name: "colorCode",
    label: "Color Code",
    inputType: "color",
    required: true,
    xs: 12,
    sm: 12,
    md: 4,
  },
  {
    name: "comments",
    label: "Comments",
    type: "text",
    required: false,
    multiline: true,
    maxRows: 5,
  },
];